import React from "react";
import { CheckCircle2 } from "lucide-react";
import Reveal from "@/components/Reveal";
import { Button } from "@/components/ui/button";

const highlights = [
  "10+ years of trusted travel expertise",
  "Personalized itineraries with expert planners",
  "Transparent pricing — no hidden charges",
  "Dedicated 24/7 on-trip support",
];

export default function About() {
  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="about" data-testid="about-section" className="py-20 md:py-28 px-5 md:px-8 bg-white">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <Reveal>
          <div className="relative">
            <div className="absolute -top-6 -left-6 w-32 h-32 rounded-2xl bg-[#F9B233]/20 -z-10" />
            <div className="absolute -bottom-6 -right-6 w-40 h-40 rounded-2xl bg-[#0B3D91]/10 -z-10" />
            <img
              src="https://images.unsplash.com/photo-1488646953014-85cb44e25828?crop=entropy&cs=srgb&fm=jpg&w=1000&q=85"
              alt="Traveler with map"
              loading="lazy"
              className="rounded-3xl shadow-2xl w-full h-[520px] object-cover"
            />
            <div className="absolute bottom-6 left-6 glass-white rounded-2xl px-5 py-4 shadow-lg">
              <p className="text-2xl font-bold text-[#0B3D91]">4.9<span className="text-[#F9B233]">★</span></p>
              <p className="text-xs text-[#555] mt-0.5">2,300+ verified reviews</p>
            </div>
          </div>
        </Reveal>

        <div>
          <Reveal>
            <span className="text-xs font-bold tracking-[0.2em] uppercase text-[#F9B233]">About Us</span>
            <h2 className="mt-3 text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-[#0B3D91] leading-[1.15]">
              About <span className="text-[#F9B233]">Malviya Travel</span>
            </h2>
            <p className="mt-5 text-base md:text-lg text-[#555] leading-relaxed">
              Malviya Travel is committed to creating memorable travel experiences with personalized service, affordable pricing,
              and carefully planned domestic and international tours. Whether you're planning a family vacation, honeymoon,
              corporate trip, or international holiday, our experienced travel experts help you enjoy a hassle-free journey
              from start to finish.
            </p>
          </Reveal>

          <div className="mt-8 grid sm:grid-cols-2 gap-3">
            {highlights.map((h, i) => (
              <Reveal key={h} delay={i * 60}>
                <div className="flex items-start gap-3 bg-[#F8FAFC] rounded-xl p-4 border border-gray-100">
                  <CheckCircle2 className="w-5 h-5 text-[#F9B233] shrink-0 mt-0.5" />
                  <span className="text-sm font-medium text-[#222]">{h}</span>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={240}>
            <div className="mt-8 flex flex-wrap gap-4">
              <Button
                data-testid="about-explore-btn"
                onClick={() => scrollTo("#packages")}
                className="bg-[#0B3D91] hover:bg-[#082d6d] text-white rounded-full h-12 px-8 font-semibold shadow-md hover:shadow-lg hover:scale-[1.03] transition-all"
              >
                Explore Packages
              </Button>
              <Button
                data-testid="about-contact-btn"
                onClick={() => scrollTo("#contact")}
                variant="outline"
                className="border-[#0B3D91] text-[#0B3D91] hover:bg-[#0B3D91] hover:text-white rounded-full h-12 px-8 font-semibold transition-all"
              >
                Talk to an Expert
              </Button>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
